/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAsinh } from '../../factoriesAny.js';
export var asinhDependencies = {
  typedDependencies,
  createAsinh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAsinh.generated.js
// module id = 1309
// module chunks = 2